<template>
  <div
    class="background"
    :style="{ 'border-radius': isSimulation ? borderRadius : 0,
      top: !isInverted ? '860px' : '73px'
    }"
  >
    <v-carousel
      v-if="images"
      :key="id"
      continuous
      :cycle="!isSimulation"
      hide-delimiters
      :show-arrows="false"
      height="980px"
      :style="{    
        'border-radius': isSimulation ? borderRadius : 0,
        'height': isMenu ? 'calc(90vh)' : '100%'
      }"
    >
      <v-carousel-item
        v-for="(item, i) in images"
        :key="item"
        :src="item"
        style="height: 100%;"
      />
    </v-carousel>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import uuidv1 from 'uuid/v1'
  import constants from '@/constants'
  export default {
    name: 'Background',
    data: () => ({
      images: null,
      id: null,
    }),
    computed: {
      ...mapState('app',['Carousel', 'totemIsInverted']),
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      isMenu () {
        return constants.menusRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      borderRadius () {
        return this.isSimulation ? constants.borderRadius : null
      },
      isInverted () {
        return this.$route.query.isInverted === 'true' ? true : this.totemIsInverted ? true : false
      },
    },
    watch: {
      Carousel() {
        this.images = null
        this.images = this.Carousel
        this.id = uuidv1()
      },
    },
    mounted () {
      this.images = null
      this.images = this.Carousel
      this.id = uuidv1()
    },
  }
</script>
<style scoped>
  .background {
    padding-left: 360px;
    position: fixed;
    width: 100%;
    right: 0px;
    height: calc(100vh);
  }
</style>
